module.exports = __webpack_public_path__ + "static/img/league.903666c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/games/games_colorful/league.svg
// module id = jV/h
// module chunks = 35